'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var React = require('react');
var PermissionsContext = require('./PermissionsContext.js');

const useHasPermission = (application, permission) => {
    const { isAllowed } = React.useContext(PermissionsContext["default"]);
    const [loading, setLoading] = React.useState(false);
    const [allowed, setAllowed] = React.useState(false);
    const [error, setError] = React.useState(null);
    const checkIfAllowed = () => _tslib.__awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            setAllowed(yield isAllowed(application, permission));
        }
        catch (e) {
            setError(e.message);
        }
        finally {
            setLoading(false);
        }
    });
    React.useEffect(() => {
        checkIfAllowed();
    }, [application, permission]);
    return { loading, error, allowed };
};

exports["default"] = useHasPermission;
